/* «Рейл з вішаками» (sections/hs-rail.liquid): hangers swing as the rail
   moves, dots follow the scroll, a tapped hanger lifts into its card. */
(function () {
  if (customElements.get('hs-rail')) return;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class HsRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-item]'));
      this.dots = this.querySelector('[data-dots]');
      this.detail = this.querySelector('[data-detail]');
      if (!this.track || !this.items.length) return;
      // Per hanger: angle, speed. A spring pulls it back to hanging straight.
      this.state = this.items.map(function (el) { return { el: el.querySelector('[data-swing]'), a: 0, v: 0 }; });
      this.lastX = this.track.scrollLeft;
      this.lastT = performance.now();
      this.running = false;
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.track.addEventListener('pointermove', this.onHover.bind(this));
      this.desktopNav();
      var selfH = this; this.track.addEventListener('pointerleave', function () { selfH.hx = null; });
      this.addEventListener('click', this.onClick.bind(this));
      this.collMode = !!this.querySelector('[data-open][data-handle]');
      if (this.collMode) { this.toFront(this.querySelector('.is-here')); this.buildMini(); }
      this.buildDots();
      this.depth();
      var self0 = this;
      window.addEventListener('resize', function () { self0.buildDots(); self0.depth(); });
      // Start on the second hanger when there is room, so both sides show depth.
      if (this.items.length > 2) {
        var second = this.collMode ? this.items[0] : this.items[1];
        this.track.scrollLeft = second.offsetLeft + second.offsetWidth / 2 - this.track.clientWidth / 2;
        this.lastX = this.track.scrollLeft;
        this.depth();
      }
      // A small hello on first sight so it reads as hangers, not a slider.
      if (!still && 'IntersectionObserver' in window) {
        var self = this;
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          io.disconnect();
          self.state.forEach(function (s, i) { s.v = (i % 2 ? -1 : 1) * (60 + i * 6); });
          self.kick();
        }, { threshold: 0.35 });
        io.observe(this);
      }
    }

onHover(e) {
      if (e.pointerType !== 'mouse' || still) return;
      var now = performance.now();
      if (this.hx != null) {
        var vx = (e.clientX - this.hx) / Math.max(8, now - this.ht);
        for (var i = 0; i < this.items.length; i++) {
          var r = this.items[i].getBoundingClientRect();
          if (e.clientY < r.top || e.clientY > r.bottom) continue;
          var reach = r.width * 0.9, dist = Math.abs(r.left + r.width / 2 - e.clientX);
          if (dist < reach) this.state[i].v += Math.max(-60, Math.min(60, -vx * 120 * (1 - dist / reach)));
        }
        this.kick();
      }
      this.hx = e.clientX; this.ht = now;
    }

    onScroll() {
      var now = performance.now();
      var dx = this.track.scrollLeft - this.lastX;
      var dt = Math.max(8, now - this.lastT);
      this.lastX = this.track.scrollLeft;
      this.lastT = now;
      this.paintDots();
      this.depth();
      if (still) return;
      // The rail moves left, the hangers lag behind and tilt the other way.
      var push = Math.max(-900, Math.min(900, (dx / dt) * 260));
      this.state.forEach(function (s, i) { s.v += push * (0.8 + (i % 3) * 0.12); });
      this.kick();
    }

    kick() {
      if (this.running) return;
      this.running = true;
      var self = this;
      var prev = performance.now();
      function step(now) {
        var dt = Math.min(0.032, (now - prev) / 1000);
        prev = now;
        var moving = false;
        self.state.forEach(function (s) {
          // Damped spring: stiffness 70, damping 5.5, max 14 degrees.
          s.v += (-70 * s.a - 5.5 * s.v) * dt;
          s.a += s.v * dt;
          if (s.a > 14) { s.a = 14; s.v *= -0.4; }
          if (s.a < -14) { s.a = -14; s.v *= -0.4; }
          if (Math.abs(s.a) > 0.05 || Math.abs(s.v) > 0.5) moving = true;
          if (s.el) s.el.style.setProperty('--hs-rail-rot', s.a.toFixed(2) + 'deg');
        });
        if (moving) requestAnimationFrame(step);
        else {
          self.running = false;
          self.state.forEach(function (s) { s.a = 0; s.v = 0; if (s.el) s.el.style.setProperty('--hs-rail-rot', '0deg'); });
        }
      }
      requestAnimationFrame(step);
    }

    // Each hanger's distance from the middle, in hanger widths (0 = centred).
    depth() {
      if (still) return;
      var mid = this.track.scrollLeft + this.track.clientWidth / 2;
      var best = null, bestD = 9;
      for (var i = 0; i < this.items.length; i++) {
        var el = this.items[i];
        var d = (el.offsetLeft + el.offsetWidth / 2 - mid) / (el.offsetWidth * 1.15);
        var c = Math.max(-1, Math.min(1, d)), a = Math.abs(c);
        // Centre: forward 70px, 1.14x. One hanger away: turned 28deg, 0.88x, a touch darker.
        var h = el.firstElementChild;
        if (h) {
          h.style.setProperty('--hs-z', ((1 - a) * 70).toFixed(1) + 'px');
          h.style.setProperty('--hs-ry', (c * -28).toFixed(2) + 'deg');
          h.style.setProperty('--hs-s', (1.14 - a * 0.26).toFixed(3));
          h.style.setProperty('--hs-b', (1 - a * 0.1).toFixed(3));
        }
        el.style.zIndex = String(100 - Math.round(Math.abs(d) * 10));
        if (Math.abs(d) < bestD) { bestD = Math.abs(d); best = el; }
      }
      for (var j = 0; j < this.items.length; j++) this.items[j].classList.toggle('is-centre', this.items[j] === best);
    }

    // A laptop has no swipe: arrows, drag with the mouse, the wheel scrolls sideways.
    desktopNav() {
      var self = this, t = this.track;
      var by = function (d) {
        var w = (self.items[0] ? self.items[0].offsetWidth : 200) + 20;
        t.scrollBy({ left: d * w * 2, behavior: still ? 'auto' : 'smooth' });
      };
      var p = this.querySelector('[data-rail-prev]'), n = this.querySelector('[data-rail-next]');
      if (p) p.addEventListener('click', function () { by(-1); });
      if (n) n.addEventListener('click', function () { by(1); });
      // The wheel stays with the page (QA 18.10: the rail swallowed page scrolling); arrows and drag move the rail.
      var down = null, moved = false;
      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = { x: e.clientX, left: t.scrollLeft }; moved = false;
        t.style.scrollSnapType = 'none';
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - down.x;
        if (Math.abs(dx) > 5) { moved = true; t.classList.add('is-dragging'); }
        if (moved) t.scrollLeft = down.left - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = null; t.style.scrollSnapType = ''; t.classList.remove('is-dragging');
        if (moved) { var stop = function (e) { e.stopPropagation(); e.preventDefault(); }; t.addEventListener('click', stop, { capture: true, once: true }); setTimeout(function () { t.removeEventListener('click', stop, true); }, 50); }
      });
      var edges = function () {
        var max = t.scrollWidth - t.clientWidth;
        if (p) p.disabled = t.scrollLeft <= 2;
        if (n) n.disabled = t.scrollLeft >= max - 2;
      };
      t.addEventListener('scroll', edges, { passive: true });
      edges();
    }

    buildDots() {
      if (!this.dots) return;
      var n = this.items.length > 12 ? 0 : this.items.length;   // one dot per hanger; a long rail gets none
      this.dots.innerHTML = '';
      this.dots.hidden = n < 2;
      for (var i = 0; i < n; i++) this.dots.appendChild(document.createElement('i'));
      this.paintDots();
    }
    paintDots() {
      if (!this.dots || this.dots.hidden) return;
      var dots = this.dots.children, mid = this.track.scrollLeft + this.track.clientWidth / 2, at = 0, bd = 1e9;
      for (var k = 0; k < this.items.length; k++) {
        var d = Math.abs(this.items[k].offsetLeft + this.items[k].offsetWidth / 2 - mid);
        if (d < bd) { bd = d; at = k; }
      }
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === at);
    }

    onClick(e) {
      if (e.target.closest('[data-close]')) { this.close(); return; }
      var btn = e.target.closest('[data-open]');
      if (btn) this.open(btn);
    }

    open(btn) {
      if (btn.dataset.handle) { this.pickCollection(btn); return; }
      var d = this.detail;
      if (!d) { location.href = btn.dataset.url; return; }
      var total = this.items.length;
      var two = function (n) { return (n < 10 ? '0' : '') + n; };
      var media = d.querySelector('[data-d-media]');
      var img = btn.querySelector('img');
      media.innerHTML = '';
      media.classList.toggle('is-cutout', !!btn.closest('.is-cutout'));
      if (img) {
        var copy = img.cloneNode();
        copy.removeAttribute('loading');
        copy.sizes = '260px';
        media.appendChild(copy);
      }
      d.querySelector('[data-d-count]').textContent = two(Number(btn.dataset.index) || 1) + ' / ' + two(total);
      d.querySelector('[data-d-title]').textContent = btn.dataset.title || '';
      d.querySelector('[data-d-price]').textContent = btn.dataset.price || '';
      d.querySelector('[data-d-link]').href = btn.dataset.url || '#';
      this.opener = btn;
      // The garment lifts from where it hung into the card (FLIP).
      var from = (btn.querySelector('[data-garment]') || btn).getBoundingClientRect();
      this.savedX = this.track.scrollLeft;
      this.classList.add('is-detail');
      d.hidden = false;
      var to = media.getBoundingClientRect();
      if (!still && to.width) {
        var sx = from.width / to.width, sy = from.height / to.height;
        media.animate([
          { transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + sx + ',' + sy + ')' },
          { transform: 'translate(0,-18px) scale(1.02)', offset: 0.7 },
          { transform: 'none' }
        ], { duration: 520, easing: 'cubic-bezier(.2,.8,.2,1)' });
      }
      requestAnimationFrame(function () {
        d.classList.add('is-open');
        var r = d.getBoundingClientRect();
        if (r.bottom > window.innerHeight || r.top < 0) d.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' });
      });
      this.keyHandler = this.onKey.bind(this);
      document.addEventListener('keydown', this.keyHandler);
      d.querySelector('[data-close]').focus({ preventScroll: true });
    }

    // The chosen collection hangs first («Ти тут»); everything after keeps its order.
    toFront(li) {
      if (!li || li === this.track.firstElementChild) return;
      var k = this.items.indexOf(li);
      this.track.insertBefore(li, this.track.firstElementChild);
      if (k > 0) {
        this.items.splice(k, 1); this.items.unshift(li);
        var st = this.state.splice(k, 1)[0]; this.state.unshift(st);
      }
    }

    // A slim bar of text tabs at the bottom of the screen once the big rail has
    // scrolled away, and simply stays (owner, 18.10.2026: the first version hid
    // on every scroll down and blinked while she browsed; 30.10.2026: no hangers).
    buildMini() {
      var self = this;
      var bar = document.createElement('nav');
      bar.className = 'hs-rail-mini';
      bar.setAttribute('aria-label', 'Колекції');
      var list = document.createElement('div');
      list.className = 'hs-rail-mini__track';
      this.items.forEach(function (li) {
        var b = li.querySelector('[data-open]');
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'hs-rail-mini__item';
        a.dataset.handle = b.dataset.handle;
        a.textContent = b.dataset.title;
        a.addEventListener('click', function () { self.pickCollection(b); });
        list.appendChild(a);
      });
      bar.appendChild(list);
      document.body.appendChild(bar);
      this.mini = bar; this.miniList = list;
      this.paintMini((this.querySelector('.is-here [data-open]') || {}).dataset ? this.querySelector('.is-here [data-open]').dataset.handle : null);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var on = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on);
          document.body.classList.toggle('hs-rail-mini-on', on);
        }).observe(this);
      }
    }
    paintMini(handle) {
      if (!this.miniList) return;
      var first = null;
      Array.prototype.forEach.call(this.miniList.children, function (b) {
        var on = b.dataset.handle === handle;
        b.classList.toggle('is-here', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) first = b;
      });
      if (first) { this.miniList.insertBefore(first, this.miniList.firstElementChild); this.miniList.scrollTo({ left: 0 }); }
    }

    pickCollection(btn) {
      var esc = window.CSS && CSS.escape ? CSS.escape(btn.dataset.handle) : btn.dataset.handle;
      var tab = document.querySelector('.hsc-tab[data-hsc-tab="' + esc + '"]');
      if (!tab) { location.href = btn.dataset.url; return; }
      tab.click();
      // «Ти тут» follows her choice; the hanger she took swings.
      this.items.forEach(function (li) {
        var b = li.querySelector('[data-open]'), here = b === btn, card = li.querySelector('.hs-rail__tag-card');
        li.classList.toggle('is-here', here);
        if (card) card.textContent = here ? 'Ти тут' : (card.dataset.tag || card.textContent);
      });
      var li = btn.closest('[data-item]');
      this.toFront(li);
      this.paintMini(btn.dataset.handle);
      this.track.scrollTo({ left: li.offsetLeft + li.offsetWidth / 2 - this.track.clientWidth / 2, behavior: still ? 'auto' : 'smooth' });
      var i = this.items.indexOf(li);
      if (i >= 0 && !still) { this.state[i].v = 120; this.kick(); }
      var grid = document.querySelector('.hsc-tab-panels') || tab;
      var hdr = document.querySelector('.section-header');
      var top = grid.getBoundingClientRect().top + window.scrollY - ((hdr ? hdr.offsetHeight : 80) + 12);
      var gr = grid.getBoundingClientRect();
      if (gr.top < 40 || gr.top > window.innerHeight * 0.6) window.scrollTo({ top: Math.max(0, top), behavior: still ? 'auto' : 'smooth' });
    }

    close() {
      var d = this.detail;
      if (!d || d.hidden) return;
      d.classList.remove('is-open');
      var self = this;
      d.hidden = true;
      this.classList.remove('is-detail');
      this.track.scrollLeft = this.savedX || 0;
      this.lastX = this.track.scrollLeft;
      document.removeEventListener('keydown', this.keyHandler);
      if (this.opener) {
        this.opener.focus({ preventScroll: true });
        // Back on the rail it swings a little, as if just hung up again.
        var i = this.items.indexOf(this.opener.closest('[data-item]'));
        if (i >= 0 && !still) { this.state[i].v = 90; this.kick(); }
      }
      this.opener = null;
    }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key === 'Tab' && this.detail && !this.detail.hidden) {
        var f = Array.prototype.slice.call(this.detail.querySelectorAll('a[href], button'));
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!this.detail.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      }
    }
  }
  customElements.define('hs-rail', HsRail);
})();
